// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"mode-dark"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20.5387 14.8522C20.0408 14.9492 19.5263 15 19 15C14.5817 15 11 11.4183 11 7C11 5.54296 11.3194 4.17663 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.9737 21 19.3459 18.4248 20.5387 14.8522Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20.5387 14.8522C20.0408 14.9492 19.5263 15 19 15C14.5817 15 11 11.4183 11 7C11 5.54296 11.3194 4.17663 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.9737 21 19.3459 18.4248 20.5387 14.8522Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M16.625 4L16.6692 4.08081L16.75 4.125L16.6692 4.16919L16.625 4.25L16.5808 4.16919L16.5 4.125L16.5808 4.08081L16.625 4Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M20.5 8.5L20.6768 8.82322L21 9L20.6768 9.17678L20.5 9.5L20.3232 9.17678L20 9L20.3232 8.82322L20.5 8.5Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-mode-dark')
export default class ModeDarkIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mode-dark',
    }
  }
}
